/** Třída řídící čas obnovy */
export class MapAutoRefresh {
	/** identifikátor obnovovacího času */
  private interval: ReturnType<typeof setInterval> | undefined = undefined;

	/** funkce volaná po uplynutí obnovovací periody */
	private callback: any;

	/** prodleva obnovení */
	private refreshInterval: number = 0;

	private startTime: number = performance.now();    

	init(interval: number, refreshCallback: any) {
		this.refreshInterval = interval == 0 ? 10000 : interval * 1000;
    this.callback = refreshCallback;
    this.setRefreshInterval();
  }

	setRefreshInterval() {
		clearInterval(this.interval);
		this.interval = setInterval(() => {
			this.callback();			
		}, this.refreshInterval);
		this.startTime = performance.now();
	}

	getElapsedTime(): number {
		return performance.now() - this.startTime;
	}
}
